<template>
    <transition name="fade">
        <div class="text-center" v-if="message" :class="messageClass">
            {{ message }}
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'error'
        },
        message: String
    },
    computed: {
        messageClass() {
            switch (this.type) {
                case 'success':
                    return 'bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative';
                case 'error':
                    return 'bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative ';
                case 'warning':
                    return 'bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative';
                case 'info':
                    return 'bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative';
                default:
                    return 'bg-gray-100 border border-gray-400 text-gray-700 px-4 py-3 rounded relative';
            }
        }
    }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
}
</style>
